var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[_c('router-view',[_vm._v(" "+_vm._s(_vm.$store.state.message)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }